const MODAL_STEPS = {
  CROP_MODAL_STEP: "CROP_MODAL_STEP",
  REMOVE_BACKGROUND_MODAL_STEP: "REMOVE_BACKGROUND_MODAL_STEP",
  TYPE_OF_LOGO_MODAL_STEP: "TYPE_OF_LOGO_MODAL_STEP",
};

const EMPTY_SVG_GROUPS = { group1: [], group2: [], group3: [] };
const BACKUP_STOCK_COLOR_IDS = [23, 25, 24];
const LAYER = {
  SIDES: ["front", "side", "back"],
  MAIN_SIDES: ["front", "side"], //sets team name front for most of jerseys and side for masks
  FIELDS: ["name", "number", "logo"], //artwork?
  MAIN_FIELDS: ["name", "number"],
};

const COLORS = [
  {
    id: 5,
    name: "PINK",
    slug: "pink",
    code: null,
    palette: "sublimable",
    hex: "#E365A6",
    default: null,
    playbook_match_color_id: 1,
    family_name: "pink",
    stock_name: "pink",
    chromagear_name: "pink",
  },
  {
    id: 6,
    name: "SCARLET",
    slug: "scarlet",
    code: null,
    palette: "sublimable",
    hex: "#B9121D",
    default: 1,
    playbook_match_color_id: 2,
    family_name: "red",
    stock_name: "red",
    chromagear_name: "scarlet",
  },
  {
    id: 7,
    name: "CARDINAL",
    slug: "cardinal",
    code: null,
    palette: "sublimable",
    hex: "#711A27",
    default: null,
    playbook_match_color_id: 3,
    family_name: "cardinal",
    stock_name: "cardinal",
    chromagear_name: "cardinal",
  },
  {
    id: 8,
    name: "MAROON",
    slug: "maroon",
    code: null,
    palette: "sublimable",
    hex: "#501417",
    default: null,
    playbook_match_color_id: 4,
    family_name: "maroon",
    stock_name: "maroon",
    chromagear_name: "maroon",
  },
  {
    id: 9,
    name: "ELECTRIC-PINK",
    slug: "electric-pink",
    code: null,
    palette: "sublimable",
    hex: "#DE2776",
    default: null,
    playbook_match_color_id: 5,
    family_name: "electric pink",
    stock_name: "hot-pink",
    chromagear_name: "electric-pink",
  },
  {
    id: 10,
    name: "ORANGE",
    slug: "orange",
    code: null,
    palette: "sublimable",
    hex: "#F45C08",
    default: null,
    playbook_match_color_id: 6,
    family_name: "orange",
    stock_name: "burnt-orange",
    chromagear_name: "orange",
  },
  {
    id: 11,
    name: "TEXAS",
    slug: "texas",
    code: null,
    palette: "sublimable",
    hex: "#AF6317",
    default: null,
    playbook_match_color_id: 7,
    family_name: "texas",
    stock_name: "texas-orange",
    chromagear_name: "texas-orange",
  },
  {
    id: 12,
    name: "OLD-GOLD",
    slug: "old-gold",
    code: null,
    palette: "sublimable",
    hex: "#CF9128",
    default: null,
    playbook_match_color_id: 8,
    family_name: "old gold",
    stock_name: "vegas-gold",
    chromagear_name: "old-gold",
  },
  {
    id: 13,
    name: "LIGHT-GOLD",
    slug: "light-gold",
    code: null,
    palette: "sublimable",
    hex: "#F6CD0B",
    default: null,
    playbook_match_color_id: 9,
    family_name: "gold",
    stock_name: "gold",
    chromagear_name: "light-gold",
  },
  {
    id: 14,
    name: "VEGAS-GOLD",
    slug: "vegas-gold",
    code: null,
    palette: "sublimable",
    hex: "#D6BD6C",
    default: null,
    playbook_match_color_id: 10,
    family_name: "vegas",
    stock_name: "vegas-gold",
    chromagear_name: "vegas-gold",
  },
  {
    id: 15,
    name: "DARK-GREEN",
    slug: "dark-green",
    code: null,
    palette: "sublimable",
    hex: "#0F2B03",
    default: null,
    playbook_match_color_id: 11,
    family_name: "forest",
    stock_name: "forest",
    chromagear_name: "dark-green",
  },
  {
    id: 16,
    name: "KELLY-GREEN",
    slug: "kelly-green",
    code: null,
    palette: "sublimable",
    hex: "#396C27",
    default: null,
    playbook_match_color_id: 12,
    family_name: "kelly",
    stock_name: "kelly",
    chromagear_name: "kelly-green",
  },
  {
    id: 17,
    name: "TEAL",
    slug: "teal",
    code: null,
    palette: "sublimable",
    hex: "#187269",
    default: null,
    playbook_match_color_id: 13,
    family_name: "teal",
    stock_name: "teal",
    chromagear_name: "teal",
  },
  {
    id: 18,
    name: "COLUMBIA",
    slug: "columbia",
    code: null,
    palette: "sublimable",
    hex: "#7DA1D4",
    default: null,
    playbook_match_color_id: 14,
    family_name: "columbia",
    stock_name: "columbia-blue",
    chromagear_name: "columbia-blue",
  },
  {
    id: 19,
    name: "ROYAL",
    slug: "royal",
    code: null,
    palette: "sublimable",
    hex: "#21368C",
    default: 2,
    playbook_match_color_id: 15,
    family_name: "royal",
    stock_name: "royal",
    chromagear_name: "royal-blue",
  },
  {
    id: 20,
    name: "NAVY",
    slug: "navy",
    code: null,
    palette: "sublimable",
    hex: "#10103A",
    default: null,
    playbook_match_color_id: 16,
    family_name: "navy",
    stock_name: "navy",
    chromagear_name: "navy-blue",
  },
  {
    id: 21,
    name: "PURPLE",
    slug: "purple",
    code: null,
    palette: "sublimable",
    hex: "#5E1D78",
    default: null,
    playbook_match_color_id: 17,
    family_name: "purple",
    stock_name: "purple",
    chromagear_name: "purple",
  },
  {
    id: 22,
    name: "SILVER",
    slug: "silver",
    code: null,
    palette: "sublimable",
    hex: "#7A7774",
    default: null,
    playbook_match_color_id: 18,
    family_name: "graphite",
    stock_name: "graphite",
    chromagear_name: "silver",
  },
  {
    id: 23,
    name: "BLACK",
    slug: "black",
    code: null,
    palette: "sublimable",
    hex: "#202020",
    default: null,
    playbook_match_color_id: 19,
    family_name: "black",
    stock_name: "black",
    chromagear_name: "black",
  },
  {
    id: 24,
    name: "GREY",
    slug: "grey",
    code: null,
    palette: "sublimable",
    hex: "#C6C6C6",
    default: null,
    playbook_match_color_id: 20,
    family_name: "silver",
    stock_name: "silver",
    chromagear_name: "grey",
  },
  {
    id: 25,
    name: "WHITE",
    slug: "white",
    code: null,
    palette: "sublimable",
    hex: "#FFFFFF",
    default: 3,
    playbook_match_color_id: 21,
    family_name: "white",
    stock_name: "white",
    chromagear_name: "white",
  },
];

const SPANSHEET_COLORS_IDS = [
  5, 6, 7, 8, 10, 13, 14, 15, 16, 18, 19, 20, 21, 22, 23, 25,
];

const DEFAULT = {
  FILL: "#FFFFFF",
  OUTLINE: "#111111",
  FONT: "block",
  FILL_ID: 25,
  OUTLINE_ID: 23,
  C1: 19,
  C2: 13,
  C3: 25,
};

const DEFAULT_PRODUCT_DATA = {
  color_1: DEFAULT.C1,
  color_2: DEFAULT.C2,
  color_3: DEFAULT.C3,
};

const DEFAULT_SCREEN_LOGO_PROPERTIES = {
  position: 2,
  zoom: 4,
};

const DEFAULT_GRID_LAYOUTS_IDS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const FLASH_BUILDER_S3_BUCKET =
  "https://s3.amazonaws.com/marketing.foundersportgroup.com/flash-builder/";

const FONTS = [
  {
    label: "Full Block",
    id: 1,
    file: "full_block",
  },
  {
    label: "Apache",
    id: 2,
    file: "apache",
  },
  {
    label: "Collegiate",
    id: 3,
    file: "collegiate",
  },
  {
    label: "Falcon",
    id: 4,
    file: "falcon",
  },
  {
    label: "Warrior 1",
    id: 5,
    file: "warrior_1",
  },
  {
    label: "University",
    id: 6,
    file: "university",
  },
];

const BASE_PLAYBOOK_PAGES = [
  {
    type: "Cover",
  },
  {
    type: "Index",
  },
];

const BACK_PLAYBOOK_PAGES = {
  type: "BackCover",
};

const SNAPSHEET_PRODUCTS_PER_PAGE = 3;

const PROJECT_MODES = {
  CREATE: "create",
  EDIT: "edit",
  PREVIEW: "preview",
};

const SNAPSHEET_PLACEHOLDER_PRODUCT_ALIAS = "412000";

const PROJECT_STATUS = {
  ARCHIVED: "archived",
  COMPLETE: "complete",
  DRAFT: "draft",
  PUBLISHED: "published",
  // OMG_STATUS: 'OMG Store Requested',
  QUOTE_STATUS: "quote",
  // CLOSED_STATUS: 'closed',
  // OPEN_STATUS: 'open',
  OPEN_LOCKER: "locker",
};

const FSG_PLAYBOOK_SPORTS_CARDS = [
  {
    name: "football",
    slug: "fsg_football",
  },
  {
    name: "basketball",
    slug: "fsg_basketball",
  },
  {
    name: "baseball",
    slug: "fsg_baseball",
  },
  {
    name: "fastpitch",
    slug: "fsg_fastpitch",
  },
  {
    name: "volleyball",
    slug: "fsg_volleyball",
  },
  {
    name: "soccer",
    slug: "fsg_soccer",
  },
  {
    name: "track",
    slug: "fsg_track",
  },
  {
    name: "lacrosse",
    slug: "fsg_lacrosse",
  },
  {
    name: "training",
    slug: "fsg_training",
  },
  {
    name: "coaches",
    slug: "fsg_coaches",
  },
];

const UA_PLAYBOOK_SPORTS_CARDS = [
  {
    name: "baseball",
    slug: "baseball",
  },
  {
    name: "soccer men",
    slug: "soccer_m",
  },
  {
    name: "soccer women",
    slug: "soccer_w",
  },
  {
    name: "football",
    slug: "football",
  },
  {
    name: "volleyball women",
    slug: "volleyball_w",
  },
  {
    name: "armourfuse men",
    slug: "armourfuse_m",
  },
  {
    name: "armourfuse women",
    slug: "armourfuse_w",
  },
  {
    name: "training men",
    slug: "training_m",
  },
  {
    name: "training women",
    slug: "training_w",
  },
  {
    name: "lacrosse men",
    slug: "lacrosse_m",
  },
  {
    name: "lacrosse women",
    slug: "lacrosse_w",
  },
  {
    name: "softball",
    slug: "softball",
  },
  {
    name: "track men",
    slug: "track_m",
  },
  {
    name: "track women",
    slug: "track_w",
  },
  {
    name: "basketball men",
    slug: "basketball_m",
  },
  {
    name: "basketball women",
    slug: "basketball_w",
  },
  {
    name: "headwear",
    slug: "headwear",
  },
  {
    name: "footwear",
    slug: "footwear",
  },
  {
    name: "accessories",
    slug: "accessories",
  },
  {
    name: "baseball protective",
    slug: "baseball_protective",
  },
  {
    name: "softball protective",
    slug: "softball_protective",
  },
  {
    name: "baseball softball accessories",
    slug: "baseball_softball_accessories",
  },
  {
    name: "hockey",
    slug: "hockey",
  },
  {
    name: "basketball youth",
    slug: "basketball_y",
  },
  {
    name: "10 day tee",
    slug: "10_day_tee",
  },
  {
    name: "volleyball premier",
    slug: "volleyball_premier",
  },
];

const PRODUCT_DECORATIONS_STRUCTURE = {
  front: {
    name: { value: "", fill: "", outline: "" },
    number: { value: "", fill: "", outline: "" },
    logo: {
      id: "",
      content: "",
      position: DEFAULT_SCREEN_LOGO_PROPERTIES.position,
      zoom: DEFAULT_SCREEN_LOGO_PROPERTIES.zoom,
      url: "",
    },
  },
  back: {
    name: { value: "", fill: "", outline: "" },
    number: { value: "", fill: "", outline: "" },
    logo: {
      id: "",
      content: "",
      position: DEFAULT_SCREEN_LOGO_PROPERTIES.position,
      zoom: DEFAULT_SCREEN_LOGO_PROPERTIES.zoom,
      url: "",
    },
  },
  side: {
    name: { value: "", fill: "", outline: "" },
    number: { value: "", fill: "", outline: "" },
    logo: {
      id: "",
      content: "",
      position: DEFAULT_SCREEN_LOGO_PROPERTIES.position,
      zoom: DEFAULT_SCREEN_LOGO_PROPERTIES.zoom,
      url: "",
    },
  },
};

const S3_BASE_URL = "https://s3.amazonaws.com/marketing.foundersportgroup.com/";

const GAMEPLAN_SESSION = "gameplan-session";

const UA_PROMO_AREA = [
  {
    image: "/images/branding/armourfuse.png",
    title: "armourfuse ®",
    rows: [
      "Brilliant, vibrant team colors permanently fused directly into textiles",
      "Limitless customization, all-inclusive pricing with exclusive UA designs and customized prints",
      "37 different colors and 16 prints available",
      "6 piece minimum order",
      "4-WEEK TURN: No Mock Approvals - 4 weeks starts when you click “Submit”. Build & Submit your order fully online at underarmourteamuniforms.com Custom Art must be in vector format, and ready for production.",
    ],
  },
  {
    image: "/images/branding/stock.png",
    title: "stock",
    rows: [
      "Pre-set designs, ready to ship",
      "Best-in-class stock fabrications for all levels of play",
      "Packaged decoration for convenience",
    ],
  },
  {
    image: "/images/branding/gameday_select.png",
    title: "gameday select",
    rows: [
      "Uniforms with pre-packaged Custom options",
      "Decoration included",
      "Multiple innovative fabrics available",
      "Sublimated tackle twill decoration",
      "Extended/Shortened lengths available",
      "Fully decorated Jersey includes: Team Name (2”, 3”, or 4”) + Front Number (4”, 5”, or 6”) + Back Number (6” or 8”). Shorts include at least 1 logo location.",
    ],
  },
];

const SHOWROOM_INSTITUTION_NAMES = ["school", "team", "event", "organization", "other"]
//const SHOWROOM_INSTITUTION_NAMES = ["school", "team"];
const PROJECT_INSTITUTION_NAMES = [
  "school",
  "team",
  "event",
  "organization",
  "other",
];

const VIEWS_3D = ["Front", "Right", "Left", "Back"];

export default {
  MODAL_STEPS,
  EMPTY_SVG_GROUPS,
  BACKUP_STOCK_COLOR_IDS,
  LAYER,
  DEFAULT,
  DEFAULT_PRODUCT_DATA,
  DEFAULT_SCREEN_LOGO_PROPERTIES,
  DEFAULT_GRID_LAYOUTS_IDS,
  COLORS,
  BASE_PLAYBOOK_PAGES,
  BACK_PLAYBOOK_PAGES,
  SPANSHEET_COLORS_IDS,
  SNAPSHEET_PRODUCTS_PER_PAGE,
  SNAPSHEET_PLACEHOLDER_PRODUCT_ALIAS,
  PROJECT_MODES,
  PROJECT_STATUS,
  GAMEPLAN_SESSION,
  FLASH_BUILDER_S3_BUCKET,
  FONTS,
  FSG_PLAYBOOK_SPORTS_CARDS,
  UA_PLAYBOOK_SPORTS_CARDS,
  PRODUCT_DECORATIONS_STRUCTURE,
  S3_BASE_URL,
  UA_PROMO_AREA,
  PROJECT_INSTITUTION_NAMES,
  SHOWROOM_INSTITUTION_NAMES,
  VIEWS_3D,
};
